<template>
    <div class="navbar py-24 px-36 flex justify-start" >
        <div @click="back" class="h-full back-btn">
            <WFIcon name="back-btn" class="contain w-52 h-52"></WFIcon>
        </div>
        <div class="flex-grow flex justify-center items-center">
            <button v-if="currentPOI" class="th-btn th-btn-active w-512" @click="showInstructions"><WFTranslate k="path-instructions" class="mt-2"></WFTranslate></button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
//import { WFIcon, WFTranslate } from '@3dwayfinder/wayfinder-vue-components'


export default {
    components: {
        
        
    },
	computed: {
		...mapState('wf', ['language']),
		...mapState(['currentPOI']),
	}, 
    methods: {
        back () {
           this.$store.dispatch("setBack");
        },
        showInstructions() {
            this.$store.commit("setMapTab", "instructions");
            this.$store.commit("set360", "");
            this.$wayfinder.showPath(this.currentPOI.getNode(), this.currentPOI);
        }
    }
}
</script>
<style scoped>

</style>